import { Alert, Box, Button, Checkbox, Container, FormControl, FormControlLabel, FormGroup, Typography } from '@mui/material';
import TextField from '@mui/material/TextField';
import LoadingButton from '@mui/lab/LoadingButton';
import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import { validateEmail } from '../../../features/user/email';
import CompanyDetails from '../../common/company/details';
import UserDetails from '../../common/user/profileDetails';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { IRegisterCompState } from './IRegisterCompState';
import { RegStage } from '../../../features/user/userSlice';
import CompanyBilling from '../../common/company/billing';

const steps = [
  'Welcome',
  'Your Details',
  'Company Details',
];


export default function Register (
  {
    onRegister,
    step,
    defaultProps,
    disabledProps,
    registerError,
    message,
    onLoginButton,
    hideTerms,
    titlePerson,
    useCase
  }: 
  {
    onRegister: (data: any) => Promise<void>, 
    onLoginButton?: () => void, 
    registerError: string,
    message: string,
    defaultProps?: IRegisterCompState,
    disabledProps: Array<string>,
    registrationStage: RegStage,
    step: number,
    hideTerms?: boolean,
    titlePerson?: string,
    useCase?: string
  }) {

  const [data, setData] = useState<IRegisterCompState>({ 
    userEmail: defaultProps?.userEmail ?? '', 
    userPassword: defaultProps?.userPassword ?? '',
    userPassword2: defaultProps?.userPassword2 ?? '',
    userName: defaultProps?.userName ?? '',
    userPhone: defaultProps?.userPhone ?? '',
    name: defaultProps?.name ?? '',
    legalAddress: defaultProps?.legalAddress ?? '',
    VATNumber: defaultProps?.VATNumber ?? '',
    locationStreet: defaultProps?.locationStreet ?? '',
    locationBuilding: defaultProps?.locationBuilding ?? '',
    locationApt: defaultProps?.locationApt ?? '',
    locationCity: defaultProps?.locationCity ?? '',
    locationCountry: defaultProps?.locationCountry ?? '',
    locationZIP: defaultProps?.locationZIP ?? '',
    country: defaultProps?.country ?? '',
    country_id: defaultProps?.country_id ?? 0,
    city: defaultProps?.city ?? '',
    phone: defaultProps?.phone ?? '',
    email: defaultProps?.email ?? ''
  });

  const [errorFields, setErrorFields] = useState<Array<string>>([]);

  const [termsConditions, setTermsConditions] = useState(false);

  const [error, setError] = useState<string>('');

  useEffect(() => {

    setData({ ...data, ...defaultProps });
  }, [defaultProps]);

  useEffect(() => {

    setError(registerError);
  }, [registerError]);

  const handleRegister = (ev: any) => {

    ev.preventDefault();
    
    const errorFieldsNew = [];

    const formProps = data;

    if (useCase !== 'AddCompany') {
      if (!validateEmail(formProps.userEmail ?? '')) {
        errorFieldsNew.push('userEmail');
  
      }
      if (formProps.userPassword === '' || formProps.userPassword !== formProps.userPassword2) {
        
        errorFieldsNew.push('userPassword');
        errorFieldsNew.push('userPassword2');
      }
      if (formProps.userName === '') {
        
        errorFieldsNew.push('name');
      }
      if (formProps.name === '') {
        
        errorFieldsNew.push('name');
      }
      if (formProps.userPhone === '') {
        
        errorFieldsNew.push('userPhone');
      }
    }

    if (errorFieldsNew.length > 0) {
      setError('Please fill all required fields!');
    }
    
    if (!termsConditions && !hideTerms) {
      setError('To sign up you have to accept terms and conditions!');
      return false;
    }
    
    setErrorFields(errorFieldsNew);
    
    if (errorFieldsNew.length === 0) {
      onRegister(data);
    }

    return;
  };


  useEffect(() => {
    const listener = (event: any) => {
      
      if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        
        //   submitHandler(event);
      }
    };
    document.addEventListener('keydown', listener);
    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, []);

  return <>
    
    <Container
      maxWidth="sm">
      <FormControl>
        {/*<Stepper activeStep={step-1} alternativeLabel>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
          </Stepper>*/}
        {error ? <Box sx={{ padding: (theme)=>theme.spacing(1, 0) }}><Alert severity="error">{error}</Alert></Box> : null}
        {message !== '' ? 
          <><Alert severity="success">{message}</Alert> 
            {onLoginButton ? <Box sx={{ padding: (theme)=>theme.spacing(1, 0) }}><Button onClick={onLoginButton}>Login</Button></Box> : null}
          </>
          :
          <Box sx={{ margin: (theme)=>theme.spacing(1, 0) }}>
            {/* {step === 1 ? <RegisterStep1 /> : null }
            {step === 2 ? <RegisterStep2 data={data} onSetData={setData} disabledProps={[]} /> : null }
          {step === 3 ? <RegisterStep3 data={data} onSetData={setData} onRegister={submitHandler} disabledProps={[]} /> : null }*/}
            {useCase !== 'AddCompany' && <Box sx={{ padding: (theme)=>theme.spacing(1, 0) }}>
              <Typography variant="h6" gutterBottom component="div" align="left">{titlePerson ? titlePerson : 'Your details'}</Typography>
              <UserDetails 
                disabledProps={disabledProps} 
                hideFields={['userExistingPassword']} 
                errorFields={errorFields}
                data={data} onSetData={setData} />
            </Box>}
            <Box sx={{ padding: (theme)=>theme.spacing(1, 0) }}>
              <Typography variant="h6" gutterBottom component="div" align="left">Company details</Typography>
              <CompanyDetails errorFields={errorFields} disabledProps={[]} data={data} onSetData={setData} />
            </Box>
            {useCase !== 'AddCompany' && <Box sx={{ padding: (theme)=>theme.spacing(1, 0) }}>
              <Typography variant="h6" gutterBottom component="div" align="left">Billing contact</Typography>
              <CompanyBilling data={data} onSetData={setData} disabledProps={[]} />
            </Box>}
            {!hideTerms ? <Box sx={{ padding: (theme)=>theme.spacing(1, 0) }}>
              <FormGroup>
                <FormControlLabel control={<Checkbox onChange={()=>setTermsConditions(!termsConditions)} value={termsConditions} />} label="I agree to Terms and Conditions" />
              </FormGroup>
            </Box> : null}
            <LoadingButton sx={{ margin: (theme)=>theme.spacing(1, 0) }} type="submit" size="small" loading={false} variant="contained" 
              onClick={handleRegister}
            >
              REGISTER
            </LoadingButton>
          </Box>
        }
      </FormControl>
    </Container>
    
  </>;
}